import React from 'react';
import { Modal } from 'react-bootstrap';
import * as AppLabels from "../helper/AppLabels";
import { MyContext } from '../InitialSetup/MyProvider';

export default class Thankyou extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showModal: false,
        };
    }

    componentDidMount() {
        this.setState({
            showModal: this.props.ThankyouModalShow
        })
    }

    render() {

        const { goToLobbyClickEvent, seeMyContestEvent } = this.props;
        return (
            <MyContext.Consumer>
                {(context) => (
                    <>
                        <Modal
                            show={this.state.showModal}
                            dialogClassName="custom-modal thank-you-modal"
                            className="center-modal"
                        >
                            <Modal.Header>
                                <div className="header-modalbg">
                                    <i className="icon-tick-circular primary-icon"></i>
                                </div>
                            </Modal.Header>
                            <div>
                                <Modal.Body>
                                    <div className="thank-you-body">
                                        <h4>{AppLabels.JOIN_SUCCESS_TITLE}</h4>
                                        <p>{AppLabels.JOIN_SUCCESS_MESSAGE}</p>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer className='custom-modal-footer'>
                                    <div className="btn-grops-footer">
                                        <a href onClick={() => goToLobbyClickEvent(this.state, context)}>
                                            <span>{AppLabels.JOIN_MORE_POPUP} <br></br> {AppLabels.CONTESTS_POPUP}</span>
                                        </a>
                                        <a href onClick={() => seeMyContestEvent(this.state, context)}>
                                            <span>{this.props.from && this.props.from == 'MyContest' ? AppLabels.DISMISS : AppLabels.SEE_MY_CONTESTS}</span>
                                        </a>
                                    </div>
                                </Modal.Footer>
                            </div>
                        </Modal>
                    </>
                )}
            </MyContext.Consumer>
        );
    }
}